export default __webpack_public_path__ + "static/media/logo_clipped_rev_1.2ea51e98.png";